/**
 * Standalone /settings page. Today this just wraps the
 * RecordingSettingsCard so the URL keeps working; the same card is also
 * embedded in the Event tab's right column where operators actually
 * find it. Page kept so existing bookmarks / the navbar fallback note
 * (`/settings stays reachable via direct URL`) still resolve.
 */

import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';

import { RecordingSettingsCard } from '@/components/RecordingSettingsCard';

export const Settings: React.FC = () => {
  return (
    <div className="mx-auto mb-4 mt-2 max-w-3xl px-2 sm:my-8 sm:px-6">
      <div className="mb-6 flex items-center gap-2">
        <SettingsIcon className="h-6 w-6 sm:h-8 sm:w-8" />
        <h1 className="text-2xl font-semibold sm:text-3xl">Settings</h1>
      </div>
      <RecordingSettingsCard />
    </div>
  );
};

export default Settings;
